<template>
    <div data-nosnippet v-if="guide.topZipCode.length || guide.topNeighborhood.length">
        <h2 class="f4 linkSpacing" v-if="guide.geo.city && guide.geo.state">
            Zip Codes and Neighborhoods in {{guide.geo.city}}, {{guide.geo.state}}
        </h2>

        <ul v-if="guide.topZipCode.length">
            <li v-for="zip in guide.topZipCode">
                <a class="link" :href="glb.appUrl+zip.sitemapZipCodePageUrl">{{zip.displayName}} Homes For Sale</a>
            </li>
        </ul>
        <ul v-if="guide.topNeighborhood.length" class="linkSpacing">
            <li v-for="neighborhood in guide.topNeighborhood">
                <a class="link" :href="glb.appUrl+neighborhood.sitemapNeighborhoodPageUrl">
                    {{neighborhood.displayName}} Homes For Sale
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'guideArticleSeo',
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('guide', ['guide'])
    }
};
</script>
